// extracted by mini-css-extract-plugin
module.exports = {"idTooltipContent":"IDTooltip_idTooltipContent__1ZaXZ","idCol":"IDTooltip_idCol__2EJEV"};